/**
 * Where things are on the page designer's canvas, in the viewport: the sheets, and
 * the pointer during a drag. It reads the DOM, so it is apart from the pure rules
 * in pageLayoutForm.js.
 */

// The ghost of a block carried onto another sheet. The block itself stays where
// it began until it is dropped: its handle's listeners are on the element the
// pointer went down on, and moving it to another sheet would remount that
// element and leave the drag with nothing to hear the pointer's release.
export const CARRIED = 'carried';

/** The sheets on the canvas, top to bottom. On a plain layout there is one. */
export const sheetsOnCanvas = () => [...document.querySelectorAll('.page-sheet')].map(element => ({
	rect: element.getBoundingClientRect(),
	formPage: Number(element.dataset.formPage) || 1,
}));

/**
 * Where the pointer is now, in the viewport. `event.delta` is no use for this:
 * it adds what has scrolled, and a sheet is reached by scrolling, while the
 * sheet's own rectangle is measured after that scroll. A keyboard drag has no
 * pointer, so the pill's own moved top-left stands in for it.
 */
export function pointerOf(event) {
	const origin = event.activatorEvent;
	const { initial, translated } = event.active.rect.current;
	const delta = event.delta || { x: 0, y: 0 };
	const moved = initial && translated ? { x: translated.left - initial.left, y: translated.top - initial.top } : delta;
	const x = typeof origin?.clientX === 'number' ? origin.clientX + moved.x : translated?.left;
	const y = typeof origin?.clientY === 'number' ? origin.clientY + moved.y : translated?.top;
	return typeof x === 'number' && typeof y === 'number' ? { x, y } : null;
}
